import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../components/TopNav';
import SocialFooter from '../components/SocialFooter';
import { Check, Star, ShoppingCart } from '@phosphor-icons/react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardio-journey-app/artifacts/tyj7q2ct_logo%20365.png";
const BOOK_ON_TREADMILL = "https://customer-assets.emergentagent.com/job_3088e77d-725d-4c0a-bf3e-16c63c18c94f/artifacts/runwl0oy_6A648551-C917-4693-BB4E-D5C19237CCB0.jpeg";
const BOOK_COVER = "https://customer-assets.emergentagent.com/job_3088e77d-725d-4c0a-bf3e-16c63c18c94f/artifacts/coesf93v_ChatGPT%20Image%20Mar%2026%2C%202026%2C%2002_05_30%20AM.png";

const BuyBook = () => {
  return (
    <div className="min-h-screen bg-background relative overflow-hidden" data-testid="buy-book-screen">
      <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{ backgroundImage: `url(${LOGO_URL})`, backgroundPosition: 'center top 10%', backgroundRepeat: 'no-repeat', backgroundSize: '45%' }} />

      <TopNav showHome={true} />

      <main className="max-w-4xl mx-auto px-6 py-8 relative z-10">
        <div className="flex flex-col lg:flex-row gap-8 items-start">

          {/* Left: Book Images (compact) */}
          <div className="w-full lg:w-[170px] flex-shrink-0 space-y-3">
            <div className="rounded-2xl overflow-hidden shadow-xl border border-[#D4AF37]/20">
              <img src={BOOK_ON_TREADMILL} alt="Track365 Cardio Logbook in gym" className="w-full h-auto object-contain" />
            </div>
            <div className="rounded-2xl overflow-hidden shadow-xl border border-[#D4AF37]/20">
              <img src={BOOK_COVER} alt="Track365 Cardio Logbook Cover" className="w-full h-auto object-contain" />
            </div>
          </div>

          {/* Right: Book Details */}
          <div className="flex-1">
            <p className="text-[#D4AF37] text-xs uppercase tracking-wider font-semibold mb-2">Hardcover - March 5, 2026</p>
            <h1 className="text-2xl sm:text-3xl font-black text-foreground mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Track365 Cardio Logbook
            </h1>
            <p className="text-muted-foreground text-base mb-1">Machine & Digital Cardio Tracker</p>
            <p className="text-sm text-muted-foreground mb-4">by <span className="text-foreground font-medium">Shonda L Fulcher</span> (Author)</p>

            <div className="premium-card p-4 mb-6">
              <div className="flex items-baseline gap-2 mb-2">
                <span className="text-3xl font-black text-[#D4AF37]" style={{ fontFamily: 'Outfit, sans-serif' }}>$24.99</span>
                <span className="text-sm text-muted-foreground">Hardcover</span>
              </div>
              <a
                href="https://track365cardio.com/book"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-bold px-6 py-3 rounded-full hover:bg-[#F3E5AB] transition-all text-sm"
                data-testid="buy-book-btn"
              >
                <ShoppingCart weight="bold" className="w-4 h-4" />
                Buy Now
              </a>
            </div>

            <div className="space-y-4">
              <p className="text-foreground leading-relaxed">
                Take control of your cardio training with a structured system built for measurable progress.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Track365 Cardio Logbook is a 12-month equipment-based fitness tracker designed for individuals who want consistent, organized, and trackable cardio performance.
              </p>
              <p className="text-muted-foreground leading-relaxed">
                Whether you train indoors or outdoors, this logbook helps you record and monitor:
              </p>
              <ul className="space-y-1.5">
                {['Distance', 'Start & End times', 'Pace / Speed', 'Incline / Resistance', 'Calories'].map(item => (
                  <li key={item} className="flex items-center gap-2 text-sm">
                    <Check weight="bold" className="w-4 h-4 text-[#D4AF37] flex-shrink-0" />
                    <span className="text-muted-foreground">{item}</span>
                  </li>
                ))}
              </ul>

              <p className="text-muted-foreground leading-relaxed">
                Built for machine and digital tracking, Track365 works seamlessly with:
              </p>
              <ul className="space-y-1.5">
                {['Smart watches', 'Phone fitness apps', 'Treadmill consoles', 'Ellipticals', 'Stationary bikes', 'Rowing machines', 'Stair climbers', 'Walking and running sessions'].map(item => (
                  <li key={item} className="flex items-center gap-2 text-sm">
                    <Star weight="fill" className="w-3 h-3 text-[#D4AF37]/60 flex-shrink-0" />
                    <span className="text-muted-foreground">{item}</span>
                  </li>
                ))}
              </ul>

              <p className="text-muted-foreground leading-relaxed">
                Perfect for individuals who want a structured, equipment-based cardio tracker without distractions.
              </p>

              <p className="text-2xl font-black text-[#D4AF37] tracking-wider pt-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Start It. Do It. Accomplish It.
              </p>
            </div>
          </div>
        </div>

        <SocialFooter />
      </main>
    </div>
  );
};

export default BuyBook;
